import { render } from "./WalletPage.vue?vue&type=template&id=910e1664&scoped=true"
import script from "./WalletPage.vue?vue&type=script&lang=js"
export * from "./WalletPage.vue?vue&type=script&lang=js"

import "./WalletPage.vue?vue&type=style&index=0&id=910e1664&lang=css"
import "./WalletPage.vue?vue&type=style&index=1&id=910e1664&lang=css"
import "./WalletPage.vue?vue&type=style&index=2&id=910e1664&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910e1664"]])

export default __exports__